import React, { useEffect, useState } from "react";
import useCustomerPortalApi from "./hooks/useCustomerPortalApi";

const CustomerPortalNavBadge = () => {
  const { openCount } = useCustomerPortalApi();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const next = await openCount();
        if (!cancelled) setCount(Number(next) || 0);
      } catch (err) {
        if (!cancelled) setCount(0);
      }
    };
    load();
    const timer = setInterval(load, 60000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [openCount]);

  if (!count) return null;
  return <span className="nav-queue-badge">{count > 99 ? "99+" : count}</span>;
};

export default CustomerPortalNavBadge;
